import {
    GET_QUIZ_PLAYER_COVER,
    ANSWER_GAME_QUESTION,
    GET_NEXT_QUESTION,
    START_GAME,
    LINK_TRACKING_QUIZ_ROUTE
} from './constants';
import http from 'utils/httpService';
import { getCookie } from 'utils/cookieService';

/**
 *
 * @param id
 * @param data
 * @returns {*}
 */
const requestPlayerQuizCover = ( id, data ) => {
    const route = `${ GET_QUIZ_PLAYER_COVER }/${ id }`;
    const body = { uuid_front: getCookie( 'uuid' ), ...data };
    return http.request( route, 'POST', body );
};
/**
 *
 * @param quizID
 * @param device
 * @param preview
 * @param fields
 * @returns {*}
 */
const requestGameStart = ( quizID, device, preview, fields ) => {
    const route = `${ START_GAME }/${ quizID }`;
    const body = {
        uuid_front: getCookie( 'uuid' ),
        device_type: device,
        is_preview: preview,
        ...fields
    };
    return http.request( route, 'POST', body );
};
/**
 *
 * @param gameID
 * @param answerObject
 * @returns {*}
 */
const requestQuestionAnswer = ( gameID, answerObject ) => {
    const uuid = getCookie( 'uuid' );
    const body = {
        uuid_front: uuid,
        game_id: gameID,
        answer: answerObject
    };
    return http.request( ANSWER_GAME_QUESTION, 'POST', body );
};
/**
 *
 * @param quizID
 * @param data
 * @returns {*}
 */
const requestUserDetails = ( quizID, data ) => {
    const uuid = getCookie( 'uuid' );
    const route = `${ START_GAME }/${ quizID }?sj_n=${ data.sj_n }&sj_e=${ data.sj_e }&sj_m=${ data.sj_m }`;

    // const body = {
    //     uuid_front: uuid,
    //     ...data
    // };
    return http.request( route, 'GET' );
};
/**
 *
 * @param gameID
 * @returns {*}
 */
const requestNextQuestion = ( gameID ) => {
    const uuid = getCookie( 'uuid' );
    const body = {
        uuid_front: uuid,
        game_id: gameID,
    };
    return http.request( GET_NEXT_QUESTION, 'POST', body );
};

/**
 *
 * @param advSource
 * @param quiz_localization_id
 * @param external_url
 * @returns {*}
 */

const sendLinkTrackingData = ( advSource, quiz_localization_id, external_url ) => {
    const route = LINK_TRACKING_QUIZ_ROUTE;
    const body = {
        uuid_front: getCookie( 'uuid' ),
        advSource,
        quiz_localization_id,
        external_url
    };

    return http.request( route, 'POST', body );
};


export {
    requestPlayerQuizCover,
    requestQuestionAnswer,
    requestNextQuestion,
    requestGameStart,
    sendLinkTrackingData,
    requestUserDetails
};
